<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addHeros">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <select class="mb-3 form-control" v-model="typesValue" name="" id="">
      <option value="">{{ $t('filterByType') }}</option>
      <option value="home">{{ $t('homePage') }}</option>
      <option value="homeSlider">{{ $t('homeSlider') }}</option>
      <option value="contact">{{ $t('contactPage') }}</option>
      <option value="products">{{ $t('productsPage') }}</option>
      <option value="gallery">{{ $t('galleryPage') }}</option>
    </select>
    <CTableWrapper ref="table" hover striped :caption="$t('heros')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      typesValue: '',
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 99,
      fields: [
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: false },
        { key: 'type', label: i18n.t('type'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: '', asc: true },
      loading: false
    }
  },
  computed: {
    ...mapState('heros', ['getHerosOutput']),
    ...mapState('heros', ['deleteHeroByIdOutput']),
    herosInfo: function() {
      return this.getHerosOutput ? this.getHerosOutput : null;
    },
    items: function() {
      var result = [];

      if (this.herosInfo && this.herosInfo.data && this.herosInfo.data.heroItems) {
          result = this.herosInfo.data.heroItems;
          result.forEach(photo => {
            if (photo.types && Array.isArray(photo.types)) {
              photo['type'] = photo.types.map(typeObj => typeObj.type).join(', ');
            }
          });
      }

      return result;
    },
    pages: function()
    {
      return this.herosInfo ? this.herosInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('heros', ['getHeros']),
    ...mapActions('heros', ['deleteHeroById']),
    rowClicked (item, index) {
      this.$router.push({name: "HerosEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "HerosEdit", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.name, { name: item.name }))){
            this.deleteHeroById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;
      this.propertyName = 'id';
      this.type = this.typesValue;
      console.log(this.type);

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, this.propertyName, true, this.type);
      
      this.getHeros(input); 
    },
    addHeros () 
    {
      router.push({ name: 'HerosAdd' });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    typesValue:
    {
      handler: function()
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteHeroByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getHerosOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
/* body > div > div.c-wrapper > div > main > div > div > div.card > div > div:nth-child(1) > div > table > thead > tr > th.font-weight-bold.position-relative.pr-4 > svg{  
  display: none !important;
}
body > div > div.c-wrapper > div > main > div > div > div.card > div > div:nth-child(1) > div > table > thead > tr > th:nth-child(2) > svg{  
  display: none !important;
}
body > div > div.c-wrapper > div > main > div > div > div.card > div > div:nth-child(1) > div > table > thead > tr > th:nth-child(3) > svg{  
  display: none !important;
}
body > div > div.c-wrapper > div > main > div > div > div.card > div > div:nth-child(1) > div > table > thead > tr > th:nth-child(4) > svg{  
  display: none !important;
} */
</style> 